module.exports = __webpack_public_path__ + "img/reference-naturwacht.204bebce.jpg";